import { INTERVAL_MAX, INTERVAL_MIN, INTERVAL_STEP } from '@autopilot/contracts';

export function validateInterval(v: number | null | undefined): string | null {
  if (v === null || v === undefined || !Number.isFinite(v) || !Number.isInteger(v)) return 'Bitte eine ganze Minutenzahl angeben.';
  if (v < INTERVAL_MIN) return `Mindestens ${INTERVAL_MIN} Minuten.`;
  if (v > INTERVAL_MAX) return `Höchstens ${INTERVAL_MAX} Minuten (24 Stunden).`;
  if (v % INTERVAL_STEP !== 0) return `Nur Schritte von ${INTERVAL_STEP} Minuten (z. B. 15, 30, 45, 60).`;
  return null;
}

export const INTERVAL_OPTIONS: number[] = Array.from(
  { length: (INTERVAL_MAX - INTERVAL_MIN) / INTERVAL_STEP + 1 },
  (_, i) => INTERVAL_MIN + i * INTERVAL_STEP,
);

/**
 * Voraussichtlicher nächster Termin vor dem Speichern (08 §3): AUS→AN oder Intervallwechsel
 * setzt einen neuen Anker → erster Slot nach einem Intervall. Sonst bleibt der Termin.
 */
export function previewNextRun(opts: {
  wasEnabled: boolean;
  willEnable: boolean;
  oldInterval: number;
  newInterval: number;
  currentNextRunAt: string | null;
  now?: Date;
}): { at: string | null; newAnchor: boolean } {
  const now = opts.now ?? new Date();
  if (!opts.willEnable) return { at: null, newAnchor: false };
  const newAnchor = !opts.wasEnabled || opts.oldInterval !== opts.newInterval;
  if (newAnchor) return { at: new Date(now.getTime() + opts.newInterval * 60000).toISOString(), newAnchor };
  return { at: opts.currentNextRunAt, newAnchor };
}
